import React from 'react';
import { Link } from 'react-router-dom';
import './Membership.css';

const Membership = ({ data }) => {
    return (
        <section className="membership section" id={data.id}>
            <div className="container">
                <div className="section-title">
                    <h2>{data.title}</h2>
                </div>
                <p className="section-intro">{data.intro}</p>

                <div className="membership-grid">
                    <div className="membership-card">
                        <div className="card-header">
                            <i className="fas fa-check-circle"></i>
                            <h3>{data.benefitsTitle}</h3>
                        </div>
                        <ul className="benefits-list">
                            {data.benefits.map((benefit, index) => (
                                <li key={index}>
                                    <i className="fas fa-chevron-right"></i>
                                    {benefit}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="membership-card">
                        <div className="card-header">
                            <i className="fas fa-users"></i>
                            <h3>{data.typesTitle}</h3>
                        </div>
                        <ul className="types-list">
                            {data.types.map((type, index) => (
                                <li key={index}>
                                    <i className="fas fa-user-check"></i>
                                    {type}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="membership-form-section">
                    <h3>Join our community today</h3>
                    <p>Fill out the membership form to become part of our growing community</p>
                    <Link to="/membership#pricing" className="btn btn-primary">
                        <i className="fas fa-edit"></i> Become a Member
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Membership;
